import Api from '../Helper/Constant';
import API from '../Helper/FetchApi';

class InboundService {
    /**@GET_INBOUND_BY_ID */
    async getInboundById(id: string) {
        console.log('Fetching inbound for ID:', id);
        console.log('Using endpoint:', `/inbound/${id}`);
        
        try {
            const response = await API.fetchGet(`/inbound/${id}`);
            
            
            if (response && response.data) {
                console.log( response.data);
            }
            
            return response;
        } catch (error) {
            console.error('Error in getInboundById:', error);
            throw error;
        }
    }
}

export default new InboundService(); 